<template>
  <div class="content">
    <h2 class="text-2xl font-bold mb-4">How does Spin the Names handle my data?</h2>

    <div class="mb-6">
      <p>Spin the Names is designed to respect your privacy. We store wheel content that you save so it’s available
        across devices. We don’t use your entries for purposes beyond providing functionality.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">What we may collect</h3>
      <ul class="list-disc ml-6 mt-2">
        <li>Account details you provide (e.g., email, profile info)</li>
        <li>Saved wheel content (names/options, titles, customization settings)</li>
        <li>Usage data (device/browser type, pages visited) to improve the service</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Why we collect it</h3>
      <ul class="list-disc ml-6 mt-2">
        <li>Operate and maintain your account</li>
        <li>Store and retrieve your wheels across devices</li>
        <li>Fix issues, improve performance, and build useful features</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Cookies and tracking</h3>
      <p>Cookies help keep you logged in, remember preferences, and understand how the app is used. You can disable
        cookies in your browser settings, but some features may not work as expected.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Sharing</h3>
      <p>We may work with service providers (e.g., hosting, analytics, authentication) who access data only to perform
        their services and are not permitted to use it for other purposes.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Your choices</h3>
      <ul class="list-disc ml-6 mt-2">
        <li>Review or delete your account information via account settings</li>
        <li>Request data changes or deletion where applicable</li>
        <li>Manage cookies in your browser</li>
      </ul>
    </div>

    <div class="mb-6">
      <p>For full details, please see the <a href="/privacy-policy" class="text-blue-500 hover:underline">Privacy
          Policy</a>. If you have questions, contact <a href="mailto:ash@spinthenames.com"
          class="text-blue-500 hover:underline">ash@spinthenames.com</a>.</p>
    </div>

    <p class="mt-8 text-sm"><a href="#top" class="text-blue-500 hover:underline">Back to top</a></p>
  </div>
</template>

<script setup>
import '@components/ui/faq/faqStyles.css';
</script>
